module.exports = __webpack_public_path__ + "img/55.d8ab565f.png";